import React from 'react';
// This assumes the core skeleton styles and the @keyframes pulse are in Search.css or a global file.

// Helper to render skeleton suggestion lines
const SuggestionLineSkeleton = () => (
    <li className="suggestion-skeleton">
        {/* Text line */}
        <div className="skeleton-line medium-width" style={{ height: '16px', display: 'inline-block', marginRight: '15px' }}></div>
        {/* Pill/Tag */}
        <div className="skeleton-box" style={{ width: '60px', height: '16px', display: 'inline-block', borderRadius: '8px' }}></div>
    </li>
);

// Helper to render product card skeletons
const ProductCardSkeleton = () => (
    <div className="product-card-skeleton">
        {/* Image Placeholder */}
        <div className="product-image-placeholder skeleton-box" style={{height: '250px', marginBottom: '10px'}}></div>

        {/* Title Lines */}
        <div className="skeleton-line medium-width" style={{height: '14px'}}></div>
        <div className="skeleton-line short-width" style={{height: '12px', marginTop: '5px'}}></div>

        {/* Price Line */}
        <div className="skeleton-line extra-short-width" style={{height: '16px', marginTop: '8px'}}></div>
    </div>
);


const SearchSkeleton = () => {
    const suggestionCount = 4;
    const productCount = 6; 

    return (
        // Note: We only return the contents of the search-content div
        <div className="search-content">
            {/* Left Side - Suggestions Skeleton */}
            <div className="search-suggestions">
                {/* Heading */}
                <div className="skeleton-line short-width" style={{height: '24px', width: '150px', marginBottom: '20px'}}></div>

                <ul>
                    {Array(suggestionCount).fill(0).map((_, index) => (
                        <SuggestionLineSkeleton key={index} />
                    ))}
                </ul>
            </div>

            {/* Right Side - Products Skeleton */}
            <div className="search-results">
                {/* Heading */}
                <div className="skeleton-line short-width" style={{height: '24px', width: '100px', marginBottom: '20px'}}></div>

                <div className="product-grid skeleton-grid">
                    {Array(productCount).fill(0).map((_, index) => (
                        <ProductCardSkeleton key={index} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SearchSkeleton;